import LoadableImage from './LoadableImage';

export default LoadableImage;
